import React, {createContext, useContext, useState} from "react";
import dataFile from "../Data/dataFile.json";


const MyContext = createContext();

export const MyContextProvider = ({children}) => {
  const allVersions = dataFile["allVersions"];
  const [showTryOut, setShowTryOut] = useState(false);
  const [entity, setEntity] = useState();
  const [isExecute, setIsExecute] = useState(false); // Added state for isExecute
  const [version, setVersion] = useState();
  const [method, setMethod] = useState(); // Used to send current method data to tryout
  const [path, setPath] = useState();

  return (
    <MyContext.Provider value={{showTryOut, setShowTryOut, isExecute, setIsExecute, version, setVersion, entity, setEntity, method, setMethod, path, setPath}}>
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => {
  return useContext(MyContext);
};
